import { render } from "./unbrick-suzyq.md?vue&type=template&id=6eb1bfe3"
import script from "./unbrick-suzyq.md?vue&type=script&lang=js"
export * from "./unbrick-suzyq.md?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__